import { Injectable } from '@angular/core';
import { OrganisationsService } from '@careapp-group/ng-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CAAction } from '../actions';
import {
  CUSTOMERS,
  getEntities,
  getSelected,
  getSelectedId,
  ORGANISATIONS,
} from '../reducers/index';
import { getEnabledPriorities } from '../ui/ui.selectors';
import * as actions from './feed.actions';
import { getSelectedCustomerOrganisationId } from '../customers/customers.selectors';

@Injectable()
export class FeedEffects {
  lastFilter: any;
  getFeedPaginated = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.Feed.REQUEST_ALL_PAGINATED),
      withLatestFrom(
        this.store.select(getSelectedId(ORGANISATIONS)),
        this.store.select(getSelectedId(CUSTOMERS)),
        this.store.select(getSelectedCustomerOrganisationId),
        this.store.select(getEnabledPriorities)
      ),
      filter(
        ([
          action,
          selectedOrganisationId,
          customerId,
          selectedCustomerOrganisationId,
          priorities,
        ]) => selectedOrganisationId || selectedCustomerOrganisationId
      ),
      switchMap(
        ([
          action,
          selectedOrganisationId,
          customerId,
          selectedCustomerOrganisationId,
          priorities,
        ]) => {
          const typedAction = action as ReturnType<typeof actions.Feed.RequestAllPaginatedAction>;
          let skip: number = typedAction?.payload?.skip;
          let limit: number = typedAction?.payload?.limit;
          let priority: string = priorities?.length > 0 ? priorities[0] : null;

          const paginator = typedAction.paginator;

          const organisationId = selectedOrganisationId ?? selectedCustomerOrganisationId;

          return this.apiv2
            .getFeed({
              id: organisationId,
              skip,
              limit,
              priority,
              customerId,
            })
            .pipe(
              map((payload) => {
                if (typedAction.clear) {
                  this.store.dispatch(actions.Feed.ClearPaginationAction('feed'));
                }
                return actions.Feed.ResponseSuccessAllPaginatedAction({
                  filter: {
                    skip: skip ?? null,
                    limit: limit ?? null,
                  },
                  paginator,
                  items: payload,
                });
              }),
              catchError((err) => {
                if (typedAction.clear) {
                  this.store.dispatch(actions.Feed.ClearPaginationAction('feed'));
                }
                return of(actions.Feed.ResponseFailAllPaginatedAction(err, paginator));
              })
            );
        }
      )
    )
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private apiv2: OrganisationsService
  ) {}
}
